import React, { createContext, useCallback, useContext, useReducer, useEffect } from 'react';
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import useFetch from "v4/hooks/useFetch";
import { generateUrl } from "v4/services/api.service";
import { PROSPECT_ITEM_FORM } from "v4/data/apiRoutes";

const defaultContext = {
    prospectId: '',
    mapProspect: null,
    quote: null,
    prospect: null,
    setProspect: () => {
    },
    setMapProspect: () => {
    },
    setQuote: () => {
    }
}

const prospectPageContext = createContext(defaultContext);

export const useProspectPageContext = () => useContext(prospectPageContext);

const prospectPageReducer = (state, action) => {
    switch (action.type) {
        case 'SET_MAP_PROSPECT':
            return {
                ...state,
                mapProspect: action.payload
            }
        case 'SET_QUOTE':
            return {
                ...state,
                quote: action.payload
            }
        case 'SET_PROSPECT':
            return {
                ...state,
                prospect: action.payload
            }
        default:
            return state;
    }
}

export default function ProspectPageProvider({ children }) {
    const [state, dispatch] = useReducer(prospectPageReducer, defaultContext);
    const { currentRoute: { params } } = useNavigation();
    const [{ data }, fetchProspect] = useFetch();

    const setMapProspect = useCallback((mapProspect) => dispatch({
        type: 'SET_MAP_PROSPECT',
        payload: mapProspect,
    }), []);

    const setQuote = useCallback((quote) => dispatch({
        type: 'SET_QUOTE',
        payload: quote,
    }), []);

    const setProspect = useCallback((prospect) => dispatch({
        type: 'SET_PROSPECT',
        payload: prospect,
    }), []);

    // --- Auto-fetch MapProspect if missing ---
    useEffect(() => {
        if (!state.mapProspect && params?.prospect) {
            fetchProspect({
                url: generateUrl(PROSPECT_ITEM_FORM, { id: params.prospect })
            });
        }
    }, [state.mapProspect, fetchProspect, params]);

    useEffect(() => {
        const hydraMember = data?.['hydra:member'];
        if (hydraMember && !state.mapProspect) {
            setMapProspect(hydraMember);
        }
    }, [data, state.mapProspect, setMapProspect]);

    const contextValues = {
        ...state,
        prospectId: params?.prospect,
        setMapProspect,
        setQuote,
        setProspect,
    };

    return (
        <prospectPageContext.Provider value={contextValues}>
            {children}
        </prospectPageContext.Provider>
    )
}
